import { DisabledPrompt, Link, useUIState } from "@bcm-dev/bcms-vite";
import CustomTableAccordion, { CustomTableContent, CustomTableToggle, useCustomTableAccordion } from "components/custom-ui/CustomTableAccordion";
import { FormContainer, FormRowView, TableItemTextView, TableItemView } from "components/shared";
import React from "react";
import { SVGAsset } from "res";

/**
 * @function TransferTemplatesTableAccordion
 * @return {React.Component}
 * @exported true
 * @description This is the transfer templates table accordian.
 */
export default function TransferTemplatesTableAccordion(props) {
    const template = props.template ?? {};
    const uiStateConfig = getTemplateAccordionConfig(props.template.id);
    const { config, key } = useUIState(uiStateConfig.key, uiStateConfig.value);
    const templateName = template.name ?? "[templateName]";
    const accountFrom = `${ template.fromAccount.nickname } - ${ template.fromAccount.number }`;
    const accountTo = `${ template.toAccount.nickname } - ${ template.toAccount.number }`;
    const defaultAmount = template.defaultAmount ? template.defaultAmount.format() : "[defaultAmount]";
    const templateType = template.type ?? "[templateType]";
    const maxAmount = template.maxAmount ? template.maxAmount.format() : "[maxAmount]";
    const levelOfApprover = template.levelOfApprover ?? "[levelOfApproval]";
    const note = template.note ?? "[note]";

    return (
        <CustomTableAccordion className="transfer-templates-accordion" activeClass="open-custom-transfer-templates-accordion" state={ config.isActive }>
            <TransferTemplatesTableToggle config={ config } template={ template } templateName={ templateName } accountFrom={ accountFrom } accountTo={ accountTo } defaultAmount={ defaultAmount } />
            <TransferTemplatesTableItemContent templateType={ templateType } template={ template } maxAmount={ maxAmount } levelOfApproval={ levelOfApprover } note={ note } />
        </CustomTableAccordion>
    );
}

export const getTemplateAccordionConfig = id => ({
    key: `Accordion_${ id }`,
    value: {
        isActive: false
    }
})

/**
 * @function TransferTemplatesTableToggle
 * @param {STRING} templateName - Sets the transfer template name text.
 * @param {STRING} accountFrom - Sets the transfer account from text.
 * @param {STRING} accountTo - Sets the transfer account to text.
 * @param {STRING} defaultAmount - Sets the transfer default amount text.
 * @return {React.Component}
 * @exported false
 * @description This is the transfer templates table toggle.
 */
function TransferTemplatesTableToggle(props) {
    const template = props.template ?? {};
    const templateName = props.templateName ?? "[templateName]";
    const accountFrom = props.accountFrom ?? "[accountFrom]";
    const accountTo = props.accountTo ?? "[accountTo]";
    const defaultAmount = props.defaultAmount ?? "[defaultAmount]";
    const { state } = useCustomTableAccordion();

    return (
        <CustomTableToggle>
           <tr className="table-item-container">
                <TableItemView className="chevron-col text-center">
                    <SVGAsset id={ state ? "DownChevronIcon" : "RightChevronIcon" } className="icon" />
                </TableItemView>

                <TableItemTextView dataPoint={ `Template_Name_${ template.id }` } className="template-name-col" text={templateName} />
                <TableItemTextView className="account-from-col" text={accountFrom} />
                <TableItemTextView className="account-to-col" text={accountTo} />
                <TableItemTextView className="default-amount-col text-right" text={defaultAmount} />
            </tr>
        </CustomTableToggle>
    )
}

/**
 * @function TransferTemplatesTableItemContent
 * @param {STRING} templateType - Sets the transfer template type text.
 * @param {STRING} maxAmount - Sets the transfer maximum amount text.
 * @param {STRING} levelOfApproval - Sets the transfer level of approval text.
 * @param {STRING} note - Sets the transfer note text.
 * @return {React.Component}
 * @exported false
 * @description This is the transfer template table item content.
 */
function TransferTemplatesTableItemContent(props) {
    const template = props.template ?? {};
    const templateType = props.templateType ?? "[templateType]";
    const maxAmount = props.maxAmount ?? "[maxAmount]";
    const levelOfApproval = props.levelOfApproval ?? "[levelOfApproval]";
    const note = props.note ?? "[note]";

    return (
        <CustomTableContent>
            <tr>
                <td className="transfer-templates-table-item" colSpan="6">
                    <div className="flex-container">
                        <p className="flex-width transfer-templates-table-item-header">Template Details</p>
                        <CustomTableToggle>
                            <SVGAsset id="CloseX" className="set-width clickable" />
                        </CustomTableToggle>
                    </div>

                    <FormContainer>
                        <FormRowView dataPoint={ `Type_${ template.id }`} text="Type">
                            <p className="template-detail-text template-type">
                                <span data-point={ `Type_Value_${ template.id }`}>{ templateType }</span>
                            </p>
                        </FormRowView>
                        <FormRowView dataPoint={ `Maximum_Amount_${ template.id }`} text="Maximum Amount">
                            <p className="template-detail-text maximum-amount">
                                <span data-point={ `Maximum_Amount_Value_${ template.id }`}>{maxAmount}</span>
                            </p>

                        </FormRowView>
                        <FormRowView dataPoint={ `Level_Of_Approver_${ template.id }`} text="Level of Approver">
                            <p className="template-detail-text level-of-approver">
                                <span data-point={ `Level_Of_Approver_Value_${ template.id }`}>{levelOfApproval}</span>
                            </p>

                        </FormRowView>
                        <FormRowView dataPoint={ `Note_${ template.id }`} text="Note">
                            <p className="template-detail-text note">
                                <span data-point={ `Note_Value_${ template.id }`}>{note}</span>
                            </p>
                        </FormRowView>
                        <FormRowView className="link-container">
                            <DisabledPrompt>
                                <Link>
                                    <span data-point={ `Edit_Template_Link_${ template.id }`} className="link-text edit-template-link">Edit Template</span>
                                </Link>
                            </DisabledPrompt>
                        </FormRowView>
                        <FormRowView className="link-container">
                            <DisabledPrompt>
                                <Link>
                                    <span data-point={ `Delete_Template_Link_${ template.id }`} className="link-text delete-template-link">Delete Template</span>
                                </Link>
                            </DisabledPrompt>
                        </FormRowView>
                    </FormContainer>
                </td>
            </tr>
        </CustomTableContent>
    )
}